/* Maison du Booster : bloc « Accessoires compatibles » de la fiche produit (blocks/mdb-accessoires-compatibles.liquid,
   chantier UX du 23/09/2026). MODULE (type="module", différé par nature), chargé par le bloc seulement quand il affiche
   des accessoires. Attention : un import() dynamique dans un script classique est réécrit en require() par la chaîne
   d'assets de Shopify (inutilisable dans le navigateur) ; d'où l'import statique, comme assets/product-form.js.
   Ajout au panier SANS quitter la page, avec le mécanisme d'Horizon (le même contrat que assets/product-form.js) :
   1. événement standard CartLinesUpdateEvent (@shopify/events, action « add ») porteur d'une promesse ;
   2. POST /cart/add.js en demandant le rendu des sections du panier (cart-items-component) ;
   3. promesse résolue avec le panier à jour : le compteur de l'en-tête (cart-icon), le tiroir, la page panier et la
      quantité « déjà au panier » de la fiche se mettent à jour d'eux-mêmes ; refus du serveur : CartErrorEvent.
   Aucun panier parallèle, aucun fichier d'Horizon modifié. Retour visuel identique au bouton principal (chantier Panier,
   assets/mdb-ux-panier.*) : « Ajout… » -> « Ajouté » / erreur, rebond de l'icône panier, vibration, notification
   « Voir le panier ». Si ce module ne se charge pas : le formulaire s'envoie normalement (/cart/add puis page panier). */
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';

const MDB = (window.MDB = window.MDB || {});
const ROUTES = (typeof Theme !== 'undefined' && Theme.routes) || {};
const reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const SVG = {
  chargement: '<svg class="mdb-acc__roue" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-dasharray="36 100"/></svg>',
  succes: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  erreur: '<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5" fill="none" stroke="currentColor" stroke-width="2.2"/><path d="M12 7.6v5.4M12 16.4v.1" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>'
};
const minuteries = new WeakMap();
let dernierSucces = null;

/* (sans interaction réelle, le navigateur refuse la vibration et le signale en console) */
function vibrer(m) {
  if (navigator.userActivation && !navigator.userActivation.hasBeenActive) return;
  if (MDB.vibrer) MDB.vibrer(m);
}

/* état d'un bouton : null (normal) | 'chargement' | 'succes' | 'erreur' ; duree = retour automatique à la normale.
   La taille du bouton ne bouge pas : son contenu est masqué et une couche d'état s'affiche par-dessus ; si le mot ne
   tient pas (bouton étroit), l'icône seule reste (le message complet est dans la notification). */
function etat(b, nom, texte, duree) {
  clearTimeout(minuteries.get(b));
  if (!nom) {
    b.removeAttribute('data-mdb-etat');
    b.removeAttribute('aria-busy');
    b.removeAttribute('aria-disabled');
    return;
  }
  let couche = b.querySelector(':scope > .mdb-acc__etat');
  if (!couche) {
    couche = document.createElement('span');
    couche.className = 'mdb-acc__etat';
    couche.setAttribute('aria-hidden', 'true');
    b.appendChild(couche);
  }
  couche.classList.remove('mdb-acc__etat--icone');
  couche.innerHTML = SVG[nom] + '<span class="mdb-acc__etat-texte"></span>';
  const mot = couche.lastChild;
  mot.textContent = texte;
  b.setAttribute('data-mdb-etat', nom);
  if (mot.offsetWidth + 24 > couche.clientWidth - 16) couche.classList.add('mdb-acc__etat--icone');
  if (nom === 'chargement') { b.setAttribute('aria-busy', 'true'); b.setAttribute('aria-disabled', 'true'); }
  else { b.removeAttribute('aria-busy'); b.removeAttribute('aria-disabled'); }
  if (duree) minuteries.set(b, setTimeout(() => etat(b, null), duree));
}

/* notification : dans le tiroir panier s'il est ouvert (fenêtre modale), sinon en bas de page ; le conteneur partagé
   de MDB.toast est déplacé au bon endroit avant l'affichage (même logique que le chantier Panier) */
function dialogueOuvert() {
  let d = document.querySelector('theme-drawer#cart-drawer[open] dialog[open]');
  if (!d) { try { d = document.querySelector('dialog[open]:modal'); } catch (err) { d = null; } }
  const tiroir = d ? d.closest('theme-drawer') : null;
  return tiroir && !tiroir.hasAttribute('open') ? null : d;
}
function toast(texte, o) {
  if (!MDB.toast || !document.body) return null;
  const dlg = dialogueOuvert(), hote = dlg || document.body;
  let c = document.querySelector('.mdb-toasts'), deplace = false;
  if (!c) {
    c = document.createElement('div');
    c.className = 'mdb-toasts';
    c.setAttribute('role', 'status');
    c.setAttribute('aria-live', 'polite');
  }
  if (c.parentElement !== hote) { hote.appendChild(c); deplace = true; }
  c.classList.toggle('mdb-toasts--tiroir', !!dlg);
  if (!dlg) c.style.removeProperty('--mdb-toasts-decalage');
  /* une zone « live » tout juste insérée n'est pas toujours annoncée : court délai dans ce cas */
  const poignee = { fermer() { poignee.annule = true; if (poignee.h) poignee.h.fermer(); } };
  const lancer = () => { if (!poignee.annule) poignee.h = MDB.toast(texte, o); };
  if (deplace) setTimeout(lancer, 60); else lancer();
  return poignee;
}

function ouvrirPanier() {
  const t = document.querySelector('theme-drawer#cart-drawer');
  if (t && typeof t.open === 'function') t.open();
  else location.href = ROUTES.cart_url || '/cart';
}

/* rebond de l'icône panier de l'en-tête (animation définie par le chantier Panier ; coupée si mouvement réduit) */
function bump() {
  if (reduit) return;
  document.querySelectorAll('cart-icon').forEach((c) => {
    c.classList.remove('mdb-bump');
    void c.offsetWidth;
    c.classList.add('mdb-bump');
    clearTimeout(c.mdbBump);
    c.mdbBump = setTimeout(() => c.classList.remove('mdb-bump'), 700);
  });
}

function succes(b) {
  etat(b, 'succes', 'Ajouté', 2400);
  vibrer(15);
  bump();
  const t = document.querySelector('theme-drawer#cart-drawer');
  if (t && t.hasAttribute('open')) return;   /* tiroir ouvert : la ligne y apparaît, pas besoin de notification */
  if (dernierSucces) dernierSucces.fermer();  /* ajouts successifs : une seule notification à la fois */
  dernierSucces = toast('Ajouté au panier', { type: 'succes', action: { libelle: 'Voir le panier', fn: ouvrirPanier }, duree: 5000 });
}

function echec(b, message) {
  message = message || 'L’article n’a pas pu être ajouté. Réessayez dans un instant.';
  /* message Shopify « 3 articles seulement ont été ajoutés... » : le chiffre est le total dans le panier */
  const n = /(\d+)\s+articles?\s+seulement/i.exec(message);
  if (n) message = 'Stock limité : votre panier contient maintenant ' + (n[1] === '1' ? 'le seul exemplaire disponible.' : 'les ' + n[1] + ' exemplaires disponibles.');
  const stock = /disponib|stock|seulement|épuis|plus de|maximale/i.test(message);
  etat(b, 'erreur', stock ? 'Stock limité' : 'Non ajouté', 3500);
  vibrer([30, 60, 30]);
  toast(message, stock ? { type: 'erreur', duree: 7000, action: { libelle: 'Voir le panier', fn: ouvrirPanier } } : { type: 'erreur', duree: 6000 });
}

function sectionsPanier() {
  const ids = [];
  document.querySelectorAll('cart-items-component[data-section-id]').forEach((c) => {
    if (ids.indexOf(c.dataset.sectionId) < 0) ids.push(c.dataset.sectionId);
  });
  return ids;
}

function lirePanier() {
  return fetch((ROUTES.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
    .then((r) => { if (!r.ok) throw new Error('Lecture du panier impossible (' + r.status + ')'); return r.json(); });
}

function ajouter(form) {
  const b = form.querySelector('[data-mdb-acc-bouton]');
  const champ = form.querySelector('input[name="id"]');
  if (!b || !champ || b.getAttribute('data-mdb-etat') === 'chargement') return;
  const id = champ.value, debut = Date.now();
  etat(b, 'chargement', 'Ajout…');
  const ensuite = (fn) => setTimeout(fn, Math.max(0, 280 - (Date.now() - debut)));   /* pas de clignotement */

  let attente;
  try {
    attente = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add', context: 'product', promise: attente.promise,
      lines: [{ merchandiseId: String(id), quantity: 1 }]
    }));
  } catch (err) {
    /* API d'événements inattendue : envoi classique du formulaire (ajout puis page panier), jamais un clic ignoré */
    etat(b, null);
    HTMLFormElement.prototype.submit.call(form);
    return;
  }
  let reponse = null;
  fetch(ROUTES.cart_add_url || '/cart/add.js', {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }], sections: sectionsPanier().join(','), sections_url: location.pathname })
  }).then((r) => r.json()).then((rep) => {
    reponse = rep;
    return lirePanier();
  }).then((panier) => {
    const rate = !!(reponse && reponse.status);
    if (rate) {
      form.dispatchEvent(new CartErrorEvent({ error: reponse.message || 'Add to cart failed', code: 'INVALID',
        detail: { description: reponse.description, errors: reponse.errors } }));
    }
    attente.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(panier), detail: {
      items: panier.items, itemCount: 1, source: 'mdb-accessoires', productId: form.dataset.productId,
      sections: rate ? undefined : reponse.sections, didError: rate } });
    ensuite(() => { if (rate) echec(b, reponse.description || reponse.message); else succes(b); });
  }).catch((err) => {
    attente.reject(err);
    form.dispatchEvent(new CartErrorEvent({ error: (err && err.message) || 'Network error during add to cart', code: 'SERVICE_UNAVAILABLE' }));
    ensuite(() => echec(b, 'Connexion interrompue : l’article n’a pas été ajouté. Vérifiez votre connexion, puis réessayez.'));
  });
}

document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!form || !form.matches || !form.matches('[data-mdb-acc-form]')) return;
  e.preventDefault();
  ajouter(form);
});

/* retour arrière depuis le cache du navigateur : aucun bouton ne reste figé dans un état */
window.addEventListener('pageshow', (e) => {
  if (!e.persisted) return;
  document.querySelectorAll('[data-mdb-acc-bouton][data-mdb-etat]').forEach((b) => etat(b, null));
});
